// import React, { useEffect, useState } from "react";
// import Modal from "react-modal";
// import { Phone, Calendar, Plus } from "lucide-react";
// import "./LeadScreen.css";
// import axios from "axios";


// Modal.setAppElement("#root");

// const API_BASE = "https://api.propertygalleria.in/master/api";

// const LeadScreen = () => {


//   const [InvestorLead, setInvestorLead] = useState([]);

//   const [leads, setLeads] = useState([
//     // {
//     //   id: 1,
//     //   name: "Siva karthik",
//     //   property_title: "Property #7",
//     //   mobile_number: "0789654321",
//     //   date: "1/10/2026",
//     //   status: "Interested",
//     //   email: "siva@gmail.com",
//     //   investment: "50L",
//     //   location: "Hyderabad",
//     //   aadhar: "12345678908",
//     //   remarks: "",
//     // },
//   ]);



//   const [isAddOpen, setIsAddOpen] = useState(false);
//   const [isEditOpen, setIsEditOpen] = useState(false);
//   const [selectedLead, setSelectedLead] = useState(null);

//   const openEdit = (lead) => {
//     setSelectedLead(lead);
//     setIsEditOpen(true);
//   };

//     const fetchInvestorLead = async () => {

//         const user = JSON.parse(localStorage.getItem("user"));
//           const userId = Number(user?.id);

//       try {
//         const res = await axios.get(`${API_BASE}/investorLeads`);

//           const filtered = res.data.filter(
//                       item => Number(item.handling_agent_id) === userId
//                   );
//         setInvestorLead(filtered);
//       } catch (err) {
//         console.error(err);
//         alert("Failed to fetch Investors");
//       }
//     };
//     // console.log('this is InvestorLead',InvestorLead)

//     useEffect(() => {
//       fetchInvestorLead(InvestorLead);
//     }, []);




//   console.log('this is InvestorLead',InvestorLead)


//   return (
//     <div className="lead-container">
//       {/* Header */}
//       <div className="lead-header">
//         <h2>My Leads</h2>

//         <button className="add-btn" onClick={() => setIsAddOpen(true)}>
//           <Plus size={18} /> Add New
//         </button>
//       </div>

//       {/* Lead List */}
//       <div className="lead-list">
//         {InvestorLead.map((lead) => (
//           <div className="lead-card" key={lead.id}>
//             <div className="lead-top">
//               <h3>{lead.full_name}</h3>
//               <span className="status">{lead.status}</span>
//             </div>

//             <p className="property_title">{lead.property_title}</p>

//             <div className="lead-info">
//               <Phone size={16} />
//               <span>{lead.mobile_number}</span>
//             </div>

//             <div className="lead-info">
//               <Calendar size={16} />
//               <span>Inquired: {lead.created_at}</span>
//             </div>

//             <div
//               className="manage-lead"
//               onClick={() => openEdit(lead)}
//             >
//               Manage Lead →
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* ADD LEAD MODAL */}
//       <Modal
//         isOpen={isAddOpen}
//         onRequestClose={() => setIsAddOpen(false)}
//         className="modal"
//         overlayClassName="overlay"
//       >
//         <LeadForm
//           title="Add New Lead"
//           onClose={() => setIsAddOpen(false)}
//         />
//       </Modal>

//       {/* EDIT LEAD MODAL */}
//       <Modal
//         isOpen={isEditOpen}
//         onRequestClose={() => setIsEditOpen(false)}
//         className="modal"
//         overlayClassName="overlay"
//       >
//         <LeadForm
//           title="Edit Lead Details"
//           lead={selectedLead}
//           onClose={() => setIsEditOpen(false)}
//         />
//       </Modal>
//     </div>
//   );
// };

// export default LeadScreen;


// const LeadForm = ({ title, lead = {}, onClose }) => {
//   const [form, setForm] = useState({
//     full_name: "",
//     mobile_number: "",
//     email: "",
//     investment_range: "",
//     location: "",
//     aadhaar_number: "",
//     remarks: "",
//     status: "New",
//   });

//   useEffect(() => {
//     if (lead) {
//       setForm({
//         full_name: lead.full_name || "",
//         mobile_number: lead.mobile_number || "",
//         email: lead.email || "",
//         investment_range: lead.investment_range || "",
//         location: lead.location || "",
//         aadhaar_number: lead.aadhaar_number || "",
//         remarks: lead.remarks || "",
//         status: lead.status || "New",
//       });
//     }
//   }, [lead]);

//   const update = (key, val) =>
//     setForm({ ...form, [key]: val });

//   return (
//     <div className="modal-body">
//       <div className="modal-header">
//         <h2>{title}</h2>
//         <button onClick={onClose}>✕</button>
//       </div>

//       <div className="form-grid">
//         <input
//           placeholder="Full Name"
//           value={form.full_name}
//           onChange={(e) => update("full_name", e.target.value)}
//         />

//         <input
//           placeholder="Mobile Number"
//           value={form.mobile_number}
//           onChange={(e) => update("mobile_number", e.target.value)}
//         />

//         <input
//           placeholder="Email Address"
//           value={form.email}
//           onChange={(e) => update("email", e.target.value)}
//         />

//         <input
//           placeholder="Investment Range"
//           value={form.investment_range}
//           onChange={(e) => update("investment_range", e.target.value)}
//         />

//         <input
//           placeholder="Preferred Location"
//           value={form.location}
//           onChange={(e) => update("location", e.target.value)}
//         />

//         <input
//           placeholder="Aadhar Number"
//           value={form.aadhaar_number}
//           onChange={(e) => update("aadhaar_number", e.target.value)}
//         />
//       </div>

//       <h4 className="status-title">Lead Status Update</h4>

//       <div className="status-options">
//         {["New", "Contacted", "Call Back", "Site Visit", "Interested"].map(
//           (s) => (
//             <button
//               type="button"
//               key={s}
//               className={
//                 form.status === s
//                   ? "status-btn active"
//                   : "status-btn"
//               }
//               onClick={() => update("status", s)}
//             >
//               {s}
//             </button>
//           )
//         )}
//       </div>

//       <textarea
//         placeholder="Remarks / Notes"
//         value={form.remarks}
//         onChange={(e) => update("remarks", e.target.value)}
//       />

//       <button className="save-btn">Save Changes</button>
//     </div>
//   );
// };






import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { Phone, Calendar, Plus } from "lucide-react";
import axios from "axios";
import "./LeadScreen.css";
import AgentNavBar from "./AgentNavBar";

import { State, City } from "country-state-city";


Modal.setAppElement("#root");

const API_BASE = "https://api.propertygalleria.in/master/api";

const API_BASEE = "http://localhost:4001";


const Input = ({ label, ...props }) => (
  <div style={{ display: "flex", flexDirection: "column" }}>
    <label style={{ fontSize: 13, color: "#555", marginBottom: 6 }}>
      {label}
    </label>

    <input
      {...props}
      style={{
        padding: 12,
        borderRadius: 8,
        border: "1px solid #ddd",
        outline: "none"
      }}
    />
  </div>
);


// LeadForm FIRST
const LeadForm = ({ title, lead = {}, onClose, onSaved, projects }) => {

  console.log('this is lead', lead)
  const [form, setForm] = useState({
    full_name: "",
    mobile_number: "",
    email: "",
    investment_range: "",
    location: "",
    aadhaar_number: "",
    remarks: "",
    status: "New",
    property_id: "",
    property_title: "",
    status_updated_at: "",   // ✅ NEW
    state: "",        // ✅ ADD
    city: "",
  });

  const toLocalDateTimeInput = (dateStr) => {
    if (!dateStr) return "";

    const d = new Date(dateStr.replace(" ", "T"));
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const hh = String(d.getHours()).padStart(2, "0");
    const mi = String(d.getMinutes()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}T${hh}:${mi}`;
  };



  useEffect(() => {
    if (!lead) return;

    setForm({
      full_name: lead.full_name || "",
      mobile_number: lead.mobile_number || "",
      email: lead.email || "",
      investment_range: lead.investment_range || "",
      state: lead.state || "",
      city: lead.city || "",

      location: lead.location || "",
      aadhaar_number: lead.aadhaar_number || "",
      remarks: lead.remarks || "",
      status: lead.status
        ? lead.status
          .replace(/_/g, " ")
          .replace(/\b\w/g, c => c.toUpperCase())
        : "New",
      property_id: lead.property_id || "",
      property_title: lead.property_title || "",

      status_updated_at: lead.status_updated_at
        ? toLocalDateTimeInput(lead.status_updated_at)
        : "",


    });

  }, [lead?.id]);


  // const update = (key, val) =>
  //   setForm({ ...form, [key]: val });

  const update = (key, val) =>
    setForm(prev => ({ ...prev, [key]: val }));


  const handleSave = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));

      const payload = {
        name: form.full_name,
        email: form.email,
        mobile: form.mobile_number,
        aadhar: form.aadhaar_number,
        investmentRange: form.investment_range,
        location: form.location,
        remarks: form.remarks,
        status: form.status.toLowerCase().replace(/\s/g, "_"),
        property_id: form.property_id || null,
        property_title: form.property_title || "",
        handling_agent_id: user?.id,
        status_updated_at: form.status_updated_at
          ? form.status_updated_at.replace("T", " ")
          : null,
        state: form.state || "",
        city: form.city || "",

      };

      // ---------- ADD ----------
      if (!lead?.id) {
        await axios.post(`${API_BASE}/api/leads`, payload);
      }

      // ---------- UPDATE ----------
      else {
        await axios.put(`${API_BASE}/api/leads/${lead.id}`, payload);
      }

      alert("Lead saved successfully");
      onSaved && onSaved();

    } catch (err) {
      console.error(err);
      alert("Failed to save lead");
    }
  };


  // Inline Styles
  const styles = {
    container: { padding: '24px', fontFamily: 'Arial, sans-serif' },
    header: { marginBottom: '24px' },
    title: { fontSize: '24px', fontWeight: 'bold', color: '#0B1C3D', marginBottom: '4px' },
    subtitle: { color: '#6B7280' },
    actionsBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px', gap: '16px' },
    searchWrapper: { position: 'relative', flex: 1, maxWidth: '400px' },
    searchIcon: { position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF' },
    searchInput: { width: '100%', padding: '8px 16px 8px 36px', border: '1px solid #D1D5DB', borderRadius: '8px', outline: 'none' },
    addButton: { display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: '#8b306d', color: 'white', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer' },
    formContainer: { backgroundColor: 'white', border: '1px solid #E5E7EB', borderRadius: '8px', padding: '24px', marginBottom: '24px', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' },
    formTitle: { fontSize: '20px', fontWeight: '600', marginBottom: '16px', color: '#0B1C3D' },
    inputGroup: { marginBottom: '16px', display: 'flex', flexDirection: 'column' },
    label: { fontSize: '14px', fontWeight: '500', marginBottom: '4px', color: '#374151', textAlign: 'left' },
    required: { color: '#EF4444' },
    input: { padding: '8px 12px', border: '1px solid #D1D5DB', borderRadius: '8px', outline: 'none' },
    buttonPrimary: { backgroundColor: '#8b306d', color: 'white', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer', marginRight: '8px' },
    buttonSecondary: { backgroundColor: '#E5E7EB', color: '#374151', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer' },
    tableContainer: { backgroundColor: 'white', border: '1px solid #E5E7EB', borderRadius: '8px', overflowX: 'auto', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' },
    table: { width: '100%', borderCollapse: 'collapse' },
    th: { textAlign: 'left', padding: '12px', backgroundColor: '#8b306d', color: 'white', textAlign: 'center' },
    td: { padding: '12px', color: '#374151', textAlign: 'center' },
    badge: { display: 'inline-flex', alignItems: 'center', padding: '4px 8px', borderRadius: '999px', backgroundColor: '#42987e', color: '#fff', fontSize: '12px' },
    actionButton: { padding: '4px', borderRadius: '8px', border: 'none', cursor: 'pointer' },
    stats: { marginTop: '16px', fontSize: '14px', color: '#6B7280', textAlign: 'right' },


    pendingBadge: {
      backgroundColor: "#FEF3C7", // light yellow
      color: "#92400E",           // dark yellow
    },

    newBadge: {
      backgroundColor: "#DCFCE7", // light green
      color: "#166534",           // dark green
    },
  };


  const states = State.getStatesOfCountry("IN");
  return (
    // <div className="modal-body">
    //   {/* form UI */}
    // </div>
    <>

      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

        {/* Header */}
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #eee",
          paddingBottom: 10
        }}>
          <h2 style={{ margin: 0 }}>{title}</h2>

          <button
            onClick={onClose}
            style={{
              border: "none",
              background: "#eee",
              width: 32,
              height: 32,
              borderRadius: 8,
              cursor: "pointer",
              fontSize: 16
            }}
          >
            ✕
          </button>
        </div>

        {/* Form Grid */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))",
          gap: 14
        }}>

          <Input label="Full Name"
            value={form.full_name}
            onChange={e => update("full_name", e.target.value)}
          />

          <Input label="Mobile Number"
            value={form.mobile_number}
            onChange={e => update("mobile_number", e.target.value)}
          />

          <Input label="Email"
            value={form.email}
            onChange={e => update("email", e.target.value)}
          />

          {/* <Input label="Investment Range"
            value={form.investment_range}
            onChange={e => update("investment_range", e.target.value)}
          /> */}



          <div>
            <label style={styles.label}>Investment Range</label>
            <select
              value={form.investment_range}
              // onChange={(e) => update({ ...form, investment_range: e.target.value })}
              onChange={(e) => update("investment_range", e.target.value)}
              style={styles.input}
            >

              <option value="Select Investment Range">Select Investment Range</option>
              <option value="10-15 Lakhs">10-15 Lakhs</option>
              <option value="25-35 Lakhs">25-35 Lakhs</option>
              <option value="45-55 Lakhs">45-55 Lakhs</option>
              <option value="65-75 Lakhs">65-75 Lakhs</option>
              <option value="85-95 Lakhs">85-95 Lakhs</option>
              <option value="1Cr">1 Crore</option>
              <option value="1Cr-2Cr">1-2 Crore</option>
              <option value="3Cr-4Cr">3-4 Crore</option>
            </select>
          </div>

          {/* <Input label="Preferred Location"
            value={form.location}
            onChange={e => update("location", e.target.value)}
          /> */}

          <div style={styles.inputGroup}>
            <label style={styles.label}>State</label>
            <select
              style={styles.input}
              value={form.state}
              // onChange={(e) =>
              //   update({
              //     ...form,
              //     state: e.target.value,
              //     city: "" // reset city when state changes
              //   })
              // }
              onChange={(e) => {
                update("state", e.target.value);
                update("city", "");
              }}
              required
            >
              <option value="">Select State</option>
              {states.map((state) => (
                <option key={state.isoCode} value={state.isoCode}>
                  {state.name}
                </option>
              ))}
            </select>
          </div>
          <div style={styles.inputGroup}>
            <label style={styles.label}>City</label>
            <select
              style={styles.input}
              value={form.city}
              // onChange={(e) =>
              //   update({ ...form, city: e.target.value })
              // }
              onChange={(e) => update("city", e.target.value)}
              required
              disabled={!form.state}
            >
              <option value="">Select City</option>
              {/* {City.getCitiesOfState("IN", form.state).map((city) => (
                <option key={city.name} value={city.name}>
                  {city.name}
                </option>
              ))} */}
              {form.state &&
                City.getCitiesOfState("IN", form.state).map((city) => (
                  <option key={city.name} value={city.name}>
                    {city.name}
                  </option>
                ))}
            </select>
          </div>

          <Input label="Aadhar Number"
            value={form.aadhaar_number}
            onChange={e => update("aadhaar_number", e.target.value)}
          />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ fontSize: 13, color: "#555", marginBottom: 6 }}>
              Select Property
            </label>

            <select
              value={form.property_id || ""}
              onChange={(e) => {
                const selected = projects.find(
                  p => String(p.id) === e.target.value
                );

                update("property_id", selected?.id || "");
                update("property_title", selected?.title || "");
              }}
              style={{
                padding: 12,
                borderRadius: 8,
                border: "1px solid #ddd",
                outline: "none"
              }}
            >
              <option value="">Select Property</option>

              {projects.map(p => (
                <option key={p.id} value={p.id}>
                  {p.title} — {p.location}
                </option>
              ))}
            </select>
          </div>


        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={{ fontWeight: 600, display: "block", marginBottom: 8 }}>
            Lead Status
          </label>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 10,
            }}
          >
            {[
              "New",
              "Contacted",
              "Call Back",
              "Site Visit",
              "Interested", "Not Interested", "Blocked", "Booked",
            ].map((status) => (
              <button
                key={status}
                type="button"
                onClick={() => update("status", status)}
                style={{
                  padding: "8px 14px",
                  borderRadius: 20,
                  border:
                    form.status === status
                      ? "2px solid #8a2d5d"
                      : "1px solid #ccc",
                  background:
                    form.status === status ? "#8a2d5d" : "#fff",
                  color:
                    form.status === status ? "#fff" : "#333",
                  cursor: "pointer",
                  fontSize: 14,
                }}
              >
                {status}
              </button>
            ))}
          </div>
          <Input
            label="Status Updated At"
            type="datetime-local"
            value={form.status_updated_at}
            onChange={e => update("status_updated_at", e.target.value)}
          />

        </div>


        {/* Remarks */}
        <div>
          <label style={{ fontSize: 13, color: "#555" }}>
            Remarks / Notes
          </label>

          <textarea
            rows={3}
            value={form.remarks}
            onChange={e => update("remarks", e.target.value)}
            style={{
              width: "100%",
              padding: 12,
              borderRadius: 8,
              border: "1px solid #ddd",
              marginTop: 6
            }}
          />
        </div>

        {/* Save */}
        <button
          onClick={handleSave}
          style={{
            background: "#8a2d5d",
            color: "white",
            padding: 14,
            borderRadius: 10,
            border: "none",
            cursor: "pointer",
            fontWeight: 600,
            fontSize: 15
          }}
        >
          Save Changes
        </button>

      </div>



    </>
  );
};


const LeadScreen = () => {
  const [leads, setLeads] = useState([]);
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [projects, setProjects] = useState([]);


  const fetchProjects = async () => {
    try {
      const res = await axios.get(`${API_BASE}/get/projects`);
      setProjects(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to load projects");
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);


  const fetchInvestorLead = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = Number(user?.id);

    const res = await axios.get(`${API_BASE}/investorLeads`);

    const filtered = res.data.filter(
      item => Number(item.handling_agent_id) === userId
    );

    setLeads(filtered);
  };

  useEffect(() => {
    fetchInvestorLead();
  }, []);

  const openEdit = (lead) => {
    setSelectedLead(lead);
    setIsEditOpen(true);
  };

  const statusColor = (status) => {
    const s = status?.toLowerCase();
    if (s === "contacted") return "#0d6efd";
    if (s === "interested") return "#198754";
    if (s === "site visit") return "#6f42c1";
    return "#6c757d";
  };

  return (
    <>
      <AgentNavBar />
      <div className="lead-container">

        <div className="lead-header">
          <h2>My Leads ({leads.length})</h2>

          <button
            className="add-btn"
            onClick={() => setIsAddOpen(true)}
          >
            <Plus size={18} /> Add Lead
          </button>
        </div>

        <div className="lead-grid">
          {leads.map((lead) => (
            <div key={lead.id} className="lead-card-new">

              <div className="lead-card-top">
                <h3>{lead.full_name}</h3>

                <span
                  className="status-badge"
                  style={{ background: statusColor(lead.status) }}
                >
                  {lead.status}
                </span>
              </div>

              <p className="property">{lead.property_title}</p>

              <div className="lead-row">
                <Phone size={16} />
                {lead.mobile_number}
              </div>

              <div className="lead-row">
                <Calendar size={16} />
                {new Date(lead.status_updated_at || "No Update").toLocaleDateString()}
              </div>

              <div className="lead-extra">
                <div>
                  <small>Investment</small>
                  <strong>{lead.investment_range || "-"}</strong>
                </div>

                <div>
                  <small>Location</small>
                  <strong>{lead.location || "-"}</strong>
                </div>
              </div>

              <button
                className="manage-btn"
                onClick={() => openEdit(lead)}
              >
                Manage Lead
              </button>


            </div>
          ))}
        </div>

        <Modal
          isOpen={isAddOpen}
          onRequestClose={() => setIsAddOpen(false)}
          className="modal"
          overlayClassName="overlay"
        >
          {/* <LeadForm title="Add Lead" onClose={() => setIsAddOpen(false)} /> */}
          <LeadForm
            title="Add Lead"
            projects={projects}
            onClose={() => setIsAddOpen(false)}
            onSaved={() => {
              setIsAddOpen(false);
              fetchInvestorLead();
            }}
          />
        </Modal>

        <Modal
          isOpen={isEditOpen}
          onRequestClose={() => setIsEditOpen(false)}
          className="modal"
          overlayClassName="overlay"
        >
          {/* <LeadForm
          title="Edit Lead"
          lead={selectedLead}
          onClose={() => setIsEditOpen(false)}
        /> */}
          <LeadForm
            title="Edit Lead"
            projects={projects}
            lead={selectedLead}
            onClose={() => setIsEditOpen(false)}
            onSaved={() => {
              setIsEditOpen(false);
              fetchInvestorLead();
            }}
          />

        </Modal>
      </div>
    </>
  );
};

export default LeadScreen;
export { LeadForm };